import { Component } from '@verndale/core';
import serialize from 'form-serialize';
import axios from 'axios';
import MicroModal from 'micromodal';
import { constEvent } from '../utils/constants';

import { SERIALIZE_SETTINGS } from '../utils/default-settings';

import { dispatchGenericEvent } from '../utils/dispatch-events';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $form: this.el._$$('.modal-alternative-product-compare__add-to-cart-form'),
      $btnAddToCart: this.el._$$(
        '.modal-alternative-product-compare__add-to-cart-form button[type="submit"]'
      ),
      $btnAddToList: this.el._$$(
        '.modal-alternative-product-compare__cta-add-to-list'
      ),
      $message: this.el._$$('.modal-alternative-product-compare__message')
    };
    this.showMessageClass = 'modal-alternative-product-compare__message--show';
    this.showMessageCenterClass =
      'modal-alternative-product-compare__message--show-center';
    this.endpoint = this.dom.$form[0]?.getAttribute('action') || null;
    this.modalId = null;
    this.closeTrigger = null;

    this.init();
  } //setupDefaults

  init() {
    const { $el } = this.dom;

    const $genericModal = $el.closest('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
      this.closeTrigger = $genericModal._$$('[data-generic-modal-close]');
    }
  } //init

  addListeners() {
    const { $form, $btnAddToList } = this.dom;

    $form?._on('submit', this.addToCart.bind(this));
    $btnAddToList?._on('click', this.addToList.bind(this));
    document._on(
      constEvent.COMPARE_ALTERNATIVE_PRODUCTS,
      this.openModal.bind(this)
    );
    this.closeTrigger?._on('click', this.forceCloseModal.bind(this));
  } //addListeners

  openModal(e) {
    e?.preventDefault();

    if (this.modalId) {
      MicroModal.show(this.modalId, {
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open'
      });
    }
  } //openModal

  hideMessage($message) {
    $message.classList.remove(this.showMessageClass);
    $message.classList.remove(this.showMessageCenterClass);
  } //hideMessage

  addToCart(e) {
    e.preventDefault();
    const $form = e.currentTarget;
    const $message = $form.closest('.modal-alternative-product-compare__cta-container td')
      ._$('.modal-alternative-product-compare__message');
    const $btnAddToCart = $form._$('button[type="submit"]');
    const formData = serialize($form, SERIALIZE_SETTINGS);
    this.hideMessage($message);
    $btnAddToCart.disabled = true;

    this.post(this.endpoint, formData)
      .then(response => {
        const { success, message, body } = response?.data;
        if (success) {
          $btnAddToCart.classList.remove('btn--primary');
          $btnAddToCart.classList.add('btn--tertiary');
          const successLabel = $btnAddToCart.getAttribute('data-success-label');
          $btnAddToCart._$('span').innerText = successLabel;

          // dispatch custom event for GA4 add_to_cart on addtional required products
          const event = new CustomEvent('customAddedToCart', { detail: body });
          document.dispatchEvent(event);
        } else {
          $message.textContent = message;
          $message.classList.add(this.showMessageCenterClass);
        }
      })
      .finally(() => {
        $btnAddToCart.disabled = false;
      });
  } //addToCart

  addToList(e) {
    e.preventDefault();
    const $form = e.currentTarget;
    //const $btnAddToList = $form._$('.modal-alternative-product-compare__cta-add-to-list');
    const $btnAddToList = $form.closest('.modal-alternative-product-compare__cta-container td')
      ._$('.modal-alternative-product-compare__cta-add-to-list');

    const productId = $btnAddToList?.getAttribute('data-product-id') || null;
    dispatchGenericEvent(constEvent.SHOW_ADD_TO_LIST_MODAL, productId);
  } //addToList

  post(endpoint, data) {
    return axios({
      method: 'post',
      url: endpoint,
      data,
      headers: {
        'content-type': 'application/json'
      }
    });
  } //post

  forceCloseModal(e) {
    if (e.target.hasAttribute('data-generic-modal-close')) this.hideModal();
  } //forceCloseModal

  hideModal() {
    if (this.modalId) MicroModal.close(this.modalId);
  } //hideModal
}

export default Module;
